"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const compact_1 = __importDefault(require("lodash/compact"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const defaultKey = ['objective'];
const keys = {
    default: defaultKey,
    objective: (id) => {
        return (0, compact_1.default)([...defaultKey, id]);
    },
    objectiveWithParams: (id, params) => {
        return (0, compact_1.default)([...defaultKey, id, (0, isEmpty_1.default)(params) ? undefined : params]);
    },
    childrenCount: (id, params) => {
        return (0, compact_1.default)([...defaultKey, 'children_count', id, params]);
    },
    involvements: (id, params) => {
        return (0, compact_1.default)([...defaultKey, id, 'involvements', params]);
    },
    sharedInvolvements: (id) => {
        return (0, compact_1.default)([...defaultKey, id, 'shared-involvements']);
    },
    milestone: (id) => {
        return (0, compact_1.default)([...defaultKey, id, 'milestone-list']);
    },
    attachment: (id) => {
        return (0, compact_1.default)([...defaultKey, id, 'attachments']);
    },
    topChildrenWarning: (id) => {
        return (0, compact_1.default)([...defaultKey, id, 'top-children-warning']);
    },
    topParentWarning: (id) => {
        return (0, compact_1.default)([...defaultKey, id, 'top-parent-warning']);
    },
    sharedInvolvementsWarning: (params) => {
        return (0, compact_1.default)([...defaultKey, 'shared-involvements-warning', params]);
    },
    lastComment: (id) => {
        return (0, compact_1.default)([...defaultKey, id, 'last-comment']);
    },
    progressHistory: (params) => {
        return (0, compact_1.default)([...defaultKey, 'progress-history', params]);
    },
    customFields: (id) => {
        return (0, compact_1.default)([...defaultKey, 'custom-fields', id]);
    },
    calculationTypeOptions: [...defaultKey, 'calculation-type-options']
};
exports.default = keys;
